module.exports = __webpack_public_path__ + "img/julian-friedl.e3e69fef.jpg";